import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from '../locales/zh-CN.json'
import enUS from '../locales/en-US.json'
import jaJP from '../locales/ja-JP.json'

Vue.use(VueI18n)

// 从 localStorage 读取语言设置，默认为 zh-CN
function getLanguage() {
  const lang = localStorage.getItem('lang')
  if (lang && ['zh-CN', 'en-US', 'ja-JP'].includes(lang)) {
    return lang
  }
  return 'zh-CN'
}

const i18n = new VueI18n({
  locale: getLanguage(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'ja-JP': jaJP
  }
})

// 切换语言的方法
export function setLanguage(lang) {
  if (['zh-CN', 'en-US', 'ja-JP'].includes(lang)) {
    i18n.locale = lang
    localStorage.setItem('lang', lang)
  }
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js